import PropTypes from "prop-types";

const EyeOutlineIcon = ({ width = 24, height = 24, fill = "#7B9E7E" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9998 3.90002C16.8526 3.90002 20.89 7.39202 21.7369 12C20.8909 16.608 16.8526 20.1 11.9998 20.1C7.147 20.1 3.1096 16.608 2.2627 12C3.1087 7.39202 7.147 3.90002 11.9998 3.90002ZM11.9998 18.3C13.8353 18.2996 15.6163 17.6762 17.0514 16.5317C18.4864 15.3872 19.4904 13.7895 19.8991 12C19.4889 10.212 18.4842 8.61603 17.0494 7.47305C15.6145 6.33007 13.8343 5.7077 11.9998 5.7077C10.1653 5.7077 8.38512 6.33007 6.95023 7.47305C5.51535 8.61603 4.51069 10.212 4.1005 12C4.50918 13.7895 5.5132 15.3872 6.94823 16.5317C8.38325 17.6762 10.1643 18.2996 11.9998 18.3ZM11.9998 16.05C10.9257 16.05 9.89554 15.6233 9.13601 14.8638C8.37649 14.1043 7.9498 13.0742 7.9498 12C7.9498 10.9259 8.37649 9.89576 9.13601 9.13624C9.89554 8.37672 10.9257 7.95002 11.9998 7.95002C13.0739 7.95002 14.1041 8.37672 14.8636 9.13624C15.6231 9.89576 16.0498 10.9259 16.0498 12C16.0498 13.0742 15.6231 14.1043 14.8636 14.8638C14.1041 15.6233 13.0739 16.05 11.9998 16.05ZM11.9998 14.25C12.5965 14.25 13.1688 14.013 13.5908 13.591C14.0127 13.1691 14.2498 12.5968 14.2498 12C14.2498 11.4033 14.0127 10.831 13.5908 10.409C13.1688 9.98708 12.5965 9.75002 11.9998 9.75002C11.4031 9.75002 10.8308 9.98708 10.4088 10.409C9.98685 10.831 9.7498 11.4033 9.7498 12C9.7498 12.5968 9.98685 13.1691 10.4088 13.591C10.8308 14.013 11.4031 14.25 11.9998 14.25Z"
      fill={fill}
    />
  </svg>
);

EyeOutlineIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string
};

export default EyeOutlineIcon;
